import { useUpdateEffect } from 'react-use';

import {
   ConfidentialAccessLevel,
   PractitionerUpdateConfidentialAccessLevelCommand,
} from '@dreryk/egabinet-personnel-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { FormContextValues } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { useGetCurrentPractitionerGlobalState, useRefetchCurrentPractitioner } from '~libs.shared.account';

import { practitionersTranslationKeys } from '../../../../../translations';

import { ConfidentialDataAccessFormBean } from './ConfidentialDataAccessCell.types';

type UseConfidentialAccessLevelUpdateOptions = {
   practitionerId: number;
   watch: FormContextValues<ConfidentialDataAccessFormBean>['watch'];
};

export const useConfidentialAccessLevelUpdate = (options: UseConfidentialAccessLevelUpdateOptions): void => {
   const confidentialDataAccess = options.watch('confidentialDataAccess');
   const currentPractitioner = useGetCurrentPractitionerGlobalState();
   const refetchCurrentPractitioner = useRefetchCurrentPractitioner();

   const { executeAsync: updateConfidentialAccessLevel } = useCqrsCommand<void, ConfidentialAccessLevel>(
      (level) => {
         const command = new PractitionerUpdateConfidentialAccessLevelCommand();
         command.id = PractitionerId.of(options.practitionerId);
         command.level = level;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(practitionersTranslationKeys.confidentialAccessLevelUpdated);

            if (currentPractitioner.id === options.practitionerId) {
               refetchCurrentPractitioner();
            }
         },
      }
   );

   useUpdateEffect(() => {
      if (confidentialDataAccess) {
         updateConfidentialAccessLevel(confidentialDataAccess);
      }
   }, [confidentialDataAccess]);
};
